import React, { useState } from 'react';
import axios from 'axios';
import { THEMES } from '../theme';

const API_URL = process.env.REACT_APP_API_URL || '';

const inputClass =
  'mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-100';

/**
 * Modal de cadastro manual de post. Também usado (com `initial`) quando um
 * educador promove um lead extraído de notícia para um post investigado de verdade.
 */
function NewPostModal({ onClose, onCreated, initial = {}, submitLabel = 'Cadastrar post', endpoint = '/api/posts' }) {
  const [content, setContent] = useState(initial.content || '');
  const [theme, setTheme] = useState(initial.theme || '');
  const [platform, setPlatform] = useState(initial.platform || '');
  const [influencerUsername, setInfluencerUsername] = useState(initial.influencer_username || '');
  const [sourceUrl, setSourceUrl] = useState(initial.source_url || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const token = localStorage.getItem('access_token');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const body = endpoint === '/api/posts'
        ? { content, theme: theme || null, platform: platform || null, influencer_username: influencerUsername || null, source_url: sourceUrl || null }
        : { content, source_url: sourceUrl || null };
      await axios.post(`${API_URL}${endpoint}`, body, { headers: { Authorization: `Bearer ${token}` } });
      onCreated();
    } catch (err) {
      setError(err.response?.data?.detail || 'Não foi possível salvar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-bold text-slate-900">{submitLabel}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">✕</button>
        </div>

        {error && <div className="mb-4 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}

        <form onSubmit={submit} className="flex flex-col gap-3">
          <label className="text-sm font-medium text-slate-600">
            Texto do post
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={4}
              required
              className={inputClass}
              placeholder="Cole aqui o texto do post que você encontrou…"
            />
          </label>

          {endpoint === '/api/posts' && (
            <>
              <label className="text-sm font-medium text-slate-600">
                Tema
                <select value={theme} onChange={(e) => setTheme(e.target.value)} className={inputClass}>
                  <option value="">Selecionar…</option>
                  {THEMES.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </label>

              <div className="grid grid-cols-2 gap-3">
                <label className="text-sm font-medium text-slate-600">
                  Plataforma
                  <select value={platform} onChange={(e) => setPlatform(e.target.value)} className={inputClass}>
                    <option value="">—</option>
                    <option value="instagram">Instagram</option>
                    <option value="tiktok">TikTok</option>
                    <option value="youtube">YouTube</option>
                  </select>
                </label>
                <label className="text-sm font-medium text-slate-600">
                  Perfil (@usuário)
                  <input
                    value={influencerUsername}
                    onChange={(e) => setInfluencerUsername(e.target.value)}
                    className={inputClass}
                    placeholder="ex.: joana.exemplo"
                  />
                </label>
              </div>
            </>
          )}

          <label className="text-sm font-medium text-slate-600">
            Link do post (opcional)
            <input value={sourceUrl} onChange={(e) => setSourceUrl(e.target.value)} className={inputClass} placeholder="https://…" />
          </label>

          <div className="mt-2 flex justify-end gap-2">
            <button type="button" onClick={onClose} className="rounded-lg px-4 py-2 text-sm font-medium text-slate-500 hover:bg-slate-100">
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-60"
            >
              {loading ? 'Salvando…' : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewPostModal;
